import React from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../../core/data/routes/all_routes'
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath'

const NewFooter = () => {
  const routes = all_routes
  return (
    <>
      {/* Footer */}
      <footer>
        <div className="footer-top"
        style={{
          backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-xl-2">
                <div className="footer-widget">
                  <h5 className="mb-4" style={{color: '#fff'}}>Product</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Features</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Pricing</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Case studies</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Reviews</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Updates</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-xl-2">
                <div className="footer-widget">
                  <h5 className="mb-4" style={{color: '#fff'}}>Support</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Getting started</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Help center</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Server status</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Report a bug</Link>
                    </li>
                    <li>
                      <Link to={routes.termsCondition} style={{color: '#fff'}}>Terms & Condition</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-xl-2">
                <div className="footer-widget">
                  <h5 className="mb-4" style={{color: '#fff'}}>For Provider</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to={routes.aboutUs} style={{color: '#fff'}}>About</Link>
                    </li>
                    <li>
                      <Link to={routes.contactUs} style={{color: '#fff'}}>Contact us</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Careers</Link>
                    </li>
                    <li>
                      <Link to={routes.faq} style={{color: '#fff'}}>Faq’s</Link>
                    </li>
                    <li>
                      <Link to={routes.blogGrid} style={{color: '#fff'}}>Blog</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-xl-2">
                <div className="footer-widget">
                  <h5 className="mb-4" style={{color: '#fff'}}>Support</h5>
                  <ul className="footer-menu">
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Getting started</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Help center</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Other Products</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Report a bug</Link>
                    </li>
                    <li>
                      <Link to="https://api.whatsapp.com/send?phone=919562666362&text=Hi" style={{color: '#fff'}}>Chat support</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-xl-4">
                <div className="footer-widget">
                  <div className="card bg-light-200 border-0 mb-3">
                    <div className="card-body">
                      <h5 className="mb-3" style={{color: '#000'}}>SignUp For Subscription</h5>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Email Address"
                        />
                      </div>
                      <button
                        type="submit"
                        className="btn btn-linear-primary btn-lg w-100"
                       style={{color: '#fff'}}>
                        Subscribe
                      </button>
                    </div>
                  </div>
                  <div className="d-flex align-items-center flex-wrap">
                    <h6 className="fs-14 me-2" style={{color: '#fff'}}>Download Our App</h6>
                    <ImageWithBasePath
                      src="assets/img/icons/app-store.svg"
                      className="me-2"
                      alt="img"
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/goolge-play.svg"
                      className="me-2"
                      alt="img"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between flex-wrap mt-3">
              <ul className="social-icon mb-3">
                <li>
                  <Link to="https://www.facebook.com/profile.php?id=61552144019130">
                    <ImageWithBasePath src="assets/img/icons/fb.svg" className="img" alt="Img" />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.instagram.com/mahigo.in/">
                    <ImageWithBasePath
                      src="assets/img/icons/instagram.svg"
                      className="img"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="https://x.com/mahinchacom">
                    <ImageWithBasePath
                      src="assets/img/icons/twitter.svg"
                      className="img"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="https://api.whatsapp.com/send?phone=919562666362&text=Hi">
                    <ImageWithBasePath
                      src="assets/img/icons/whatsapp.svg"
                      className="img"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.youtube.com/@mahincha">
                    <ImageWithBasePath
                      src="assets/img/icons/youtube.svg"
                      className="img"
                      alt="Img"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.linkedin.com/in/mahincha-com/">
                    <ImageWithBasePath
                      src="assets/img/icons/linkedin.svg"
                      className="img"
                      alt="Img"
                    />
                  </Link>
                </li>
              </ul>
              <div className="d-flex align-items-center">
                <div className="dropdown me-3 mb-3">
                  <Link
                    to="#"
                    className="dropdown-toggle bg-light-300 fw-medium"
                    data-bs-toggle="dropdown"
                  >
                    <ImageWithBasePath
                      src="assets/img/flags/us.png"
                      className="flag me-2"
                      alt="Flag"
                    />
                    English
                  </Link>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to="#">
                        <ImageWithBasePath
                          src="assets/img/flags/us.png"
                          className="flag me-2"
                          alt="Flag"
                        />
                        English
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="#">
                        <ImageWithBasePath
                          src="assets/img/flags/cn.png"
                          className="flag me-2"
                          alt="Flag"
                        />
                        Chinese
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="#">
                        <ImageWithBasePath
                          src="assets/img/flags/in.png"
                          className="flag me-2"
                          alt="Flag"
                        />
                        Hindi
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="#">
                        <ImageWithBasePath
                          src="assets/img/flags/sa.png"
                          className="flag me-2"
                          alt="Flag"
                        />
                        Arabic
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="dropdown-toggle bg-light-300 fw-medium"
                    data-bs-toggle="dropdown"
                  >
                    LKR
                  </Link>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to="#">
                        INR
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="#">
                        USD
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="#">
                        SAR
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Bottom */}
        <div className="footer-bottom"
        style={{
          backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <p className="mb-2" style={{color: '#fff'}}>
                    Copyright © {new Date().getFullYear()} - All Rights Reserved Mahincha IT Solutions
                  </p>

                  <ul className="menu-links mb-2">
                    <li>
                      <Link to={routes.termsCondition} style={{color: '#fff'}}> Terms and Conditions</Link>
                    </li>
                    <li>
                      <Link to="#" style={{color: '#fff'}}>Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Footer Bottom */}
      </footer>
      {/* /Footer */}
    </>

  )
}

export default NewFooter